import * as React from "react";
import { Link } from "gatsby";
import { MdLocationOn, MdMail, MdPhone } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import { siteContent } from "../data/siteContent";

const { footer, site } = siteContent;

const MainFooter: React.FC = () => {
    return (
        <footer className="bg-surface-dark text-white font-extralight mt-20">
            <div className="px-12 py-12 lg:px-16">
                {/* Main grid */}
                <div className="grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-4">
                    {/* Logo */}
                    <div className="flex items-start">
                        <img
                            src={site.logo.white}
                            alt={site.name}
                            className="h-0 md:h-32 w-auto"
                        />
                    </div>

                    {/* Address & Contact */}
                    <div className="flex flex-col gap-4 text-md text-white/70">
                        <div className="flex items-start gap-2">
                            <MdLocationOn
                                className="mt-0.5 shrink-0 text-primary"
                                size={25}
                            />
                            <address className="not-italic leading-relaxed">
                                {footer.address.company}
                                <br />
                                {footer.address.street}
                                <br />
                                {footer.address.city}
                            </address>
                        </div>
                        <div className="flex items-center gap-2">
                            <MdPhone
                                className="shrink-0 text-primary"
                                size={25}
                            />
                            <a
                                href={footer.phone.href}
                                className="hover:text-primary transition-colors"
                            >
                                {footer.phone.display}
                            </a>
                        </div>
                        <div className="flex items-center gap-2">
                            <MdMail
                                className="shrink-0 text-primary"
                                size={25}
                            />
                            <a
                                href={footer.email.href}
                                className="hover:text-primary transition-colors"
                            >
                                {footer.email.display}
                            </a>
                        </div>
                    </div>

                    <hr className="border-white/10 md:hidden" />

                    {/* Navigation */}
                    <nav className="flex flex-col gap-3 text-md text-white/70">
                        {footer.nav.map(({ label, to }) => (
                            <Link
                                key={to}
                                to={to}
                                className="hover:text-primary transition-colors"
                            >
                                {label}
                            </Link>
                        ))}
                    </nav>

                    <hr className="border-white/10 md:hidden" />

                    {/* Social */}
                    <div className="flex items-start lg:justify-end">
                        <a
                            href={footer.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            className="text-white/70 hover:text-primary transition-colors"
                        >
                            <FaLinkedin size={28} />
                        </a>
                    </div>
                </div>

                {/* Divider */}
                <hr className="my-8 border-white/10" />

                {/* Copyright */}
                <p className="text-right text-xs text-white/50">
                    © {new Date().getFullYear()} {footer.copyright}
                </p>
            </div>
        </footer>
    );
};

export default MainFooter;
